var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
import { rethrowSimple } from "@/utils/simple-error";
import { CleanableSummary, CleanupResult, PaginationOptions } from "./Cleanup/model";
const discardedDatasetsSummaryFetcher = fetcher.path("/api/storage/datasets/discarded/summary").method("get").create();
export function fetchDiscardedDatasetsSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield discardedDatasetsSummaryFetcher({});
            return new CleanableSummary(data);
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const discardedDatasetsFetcher = fetcher.path("/api/storage/datasets/discarded").method("get").create();
export function fetchDiscardedDatasets(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            options = options !== null && options !== void 0 ? options : new PaginationOptions();
            const { data } = yield discardedDatasetsFetcher({
                offset: options.offset,
                limit: options.limit,
                order: options.order,
            });
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const datasetsCleaner = fetcher.path("/api/storage/datasets").method("delete").create();
export function cleanupDatasets(items) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const item_ids = items.map((item) => item.id);
            const { data } = yield datasetsCleaner({
                item_ids,
            });
            return new CleanupResult(data, items);
        }
        catch (error) {
            return new CleanupResult(undefined, items, error);
        }
    });
}
const discardedHistoriesSummaryFetcher = fetcher
    .path("/api/storage/histories/discarded/summary")
    .method("get")
    .create();
export function fetchDiscardedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const { data } = yield discardedHistoriesSummaryFetcher({});
            return new CleanableSummary(data);
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const discardedHistoriesFetcher = fetcher.path("/api/storage/histories/discarded").method("get").create();
export function fetchDiscardedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            options = options !== null && options !== void 0 ? options : new PaginationOptions();
            const { data } = yield discardedHistoriesFetcher({
                offset: options.offset,
                limit: options.limit,
                order: options.order,
            });
            return data;
        }
        catch (e) {
            rethrowSimple(e);
        }
    });
}
const historiesCleaner = fetcher.path("/api/storage/histories").method("delete").create();
export function cleanupHistories(items) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const item_ids = items.map((item) => item.id);
            const { data } = yield historiesCleaner({
                item_ids,
            });
            return new CleanupResult(data, items);
        }
        catch (error) {
            return new CleanupResult(undefined, items, error);
        }
    });
}
const archivedHistoriesSummaryFetcher = fetcher.path("/api/storage/histories/archived/summary").method("get").create();
export function fetchArchivedHistoriesSummary() {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield archivedHistoriesSummaryFetcher({});
        return new CleanableSummary(data);
    });
}
const archivedHistoriesFetcher = fetcher.path("/api/storage/histories/archived").method("get").create();
export function fetchArchivedHistories(options) {
    return __awaiter(this, void 0, void 0, function* () {
        options = options !== null && options !== void 0 ? options : new PaginationOptions();
        const { data } = yield archivedHistoriesFetcher({
            offset: options.offset,
            limit: options.limit,
            order: options.order,
        });
        return data;
    });
}
